<template>
  <v-card outlined class="pa-2">
    <v-row class="align-center" :class="`${arabic?'arFont':'enFont'}`">
      <v-col cols="12" class="py-0">
        <v-row class="align-center">
          <v-col cols="6" md="2">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n['seller'] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;" v-if="item.account">{{item.account.name}}</div>
          </v-col>
          <v-col cols="6" md="2">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["order_number"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:9px;">{{item.uuid}}
              <v-btn 
                v-clipboard:copy="item.uuid"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                color="success" 
                x-small 
                icon>
                <v-icon size="10">content_copy</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="3" md="2">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["order_data"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{getFormat(item.created_at)}}</span>
                </template>
                <div class="text-center">
                  <div :class="`${arabic?'arFont':'enFont'}`">
                    {{item.created_at}}
                  </div>
                </div>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="3" md="2" v-if="master">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["gross_total"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.total}} {{item.currency_symbol}} (${{item.base_total}})</div>
          </v-col>
          <v-col cols="3" md="2">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["order_status"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip color="primary" small label dark :class="`${arabic?'arFont':'enFont'}`" v-bind="attrs" v-on="on">{{statuses_obj[item.order_status] ? statuses_obj[item.order_status][language] : ''}}</v-chip>


                </template>
                <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                  {{statuses_obj[item.order_status] ? statuses_obj[item.order_status][language+'_info'] : ''}}

                </span>
              </v-tooltip>
            </div>
          </v-col>
          
          <v-col cols="3" md="2"  v-if="item.tracking_link" >
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{i18n['order_tracking']}}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">

                  <v-chip
                  color="primary"
                  outlined
                  small
                  label
                  dark
                  :href="item.tracking_link"
                  target="_blank"
                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                  v-bind="attrs"
                  v-on="on"
                >
                {{i18n['order_tracking']}}
              </v-chip>

                </template>
               
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="py-0">
        <div :class="`${arabic?'arFont':'enFont'} my-1`" style="font-weight:bold;">{{ i18n['products'] }}</div>
        <Order :lead="item" :main="true" :order="item.items" />
      </v-col>
      <v-col cols="12" class="py-0" v-if="master">
        <v-row class="align-center">
          <v-col cols="6" md="3" v-if="embed">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["customer_name"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.name}}</div>
          </v-col>
          <v-col cols="6" md="3" v-if="embed">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["phone_number"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.phone_number_1}}
              <v-btn 
                v-clipboard:copy="item.phone_number_1"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                color="success" 
                x-small 
                icon>
                <v-icon size="10">content_copy</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6" md="3" v-if="embed">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["tracking_number"]}}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.document_number}}
              <v-btn 
                v-clipboard:copy="item.document_number"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                color="success" 
                x-small 
                icon>
                <v-icon size="10">content_copy</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6" md="3" v-if="embed">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["alternative_phone"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.phone_number_2}}
              <v-btn 
                v-clipboard:copy="item.phone_number_2"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                color="success" 
                x-small 
                icon>
                <v-icon size="10">content_copy</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6" md="3" v-if="embed">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["address"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.address}}</div>
          </v-col>
          <v-col cols="6" md="3" v-if="embed">
            
          </v-col>
          <v-col cols="6" md="3" v-if="embed">
            <div :class="`${arabic?'arFont':'enFont'} success--text`" style="font-size:11px;font-weight:bold;">{{ i18n["net_profit"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'} success--text`">{{item.total_profit}} {{item.currency_symbol}}</div>
            <div :class="`${arabic?'arFont':'enFont'} success--text`" style="font-size:9px;">(${{item.base_profit}})</div>
          </v-col>
          <v-col cols="6" md="3" v-if="embed && item.dispatch_date && !item.dispatch_date.includes('Z')">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["delivery_delayed_to"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.dispatch_date}}</div>
          </v-col>
          <v-col cols="12" md="12"  v-if="embed">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["order_status_details"] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">
              {{statuses_obj[item.order_status] ? statuses_obj[item.order_status][language+'_info'] : ''}}
            </div>
          </v-col>
          <v-col cols="12" md="12"  v-if="embed && item.cancel_note">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{i18n["cancel_details"]}}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">
              {{item.cancel_note}}
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="py-0" v-if="!embed && master">
        <v-row class="align-center">
          <v-col cols="6">
            <v-btn color="success" block small :class="`${arabic?'arFont':'enFont'}`" @click="details(i)">{{  i18n["orderorder_details_lead_details"] }}</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="error" block small :class="`${arabic?'arFont':'enFont'}`" text @click="sendToCrm(i)">{{ i18n["send_to_crm"] }}</v-btn>
          </v-col>
          <v-col cols="3" v-if="false">
            <v-checkbox hide-details class="mt-0" x-small dense :label="i18n['confirm_delete']" v-model="allowDelete" :value="true"></v-checkbox>
          </v-col>
          <v-col cols="3" v-if="false">
            <v-btn color="error" :disabled="!allowDelete" small :class="`${arabic?'arFont':'enFont'}`" text @click="deleteFromNinja(i)">{{ i18n['delete_order'] }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>

</template>

<script>
import Order from './Order'
import { format, render, cancel, register } from 'timeago.js';
export default {
  components: { Order },
  props:['embed', 'item', 'i'],
  data(){
    return {
      dialog:true,
      allowDelete:false,
    }
  },
  methods:{
    clipboardSuccessHandler ({ value, event }){
      this.$emit('clipboardSuccessHandler', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('clipboardSuccessHandler', { value, event })
    },
    getFormat(d){
      return format(d)
    },
    details(i) {
      this.$emit('details', i)
    },
    rate(i) {
      this.$emit('rate', i)
    },
    message(i) {
      this.$emit('message', i)
    },
    sendToCrm(i) {
      this.$emit('sendtocrm', i)
    },
    deleteFromNinja(i) {
      this.$emit('deleteFromNinja', i)
    },
  },
  computed:{
    master(){
      return this.user.role == 'master'
    },
    statuses_obj(){
      // console.log(this.$store.state.statuses_obj)
      return this.$store.state.statuses_obj
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
}
</script>

<style>

</style>